import lidNameMap from './lidNameMap.js';

// WhatsApp group @mentions arrive as raw LID numbers (e.g. "@221693394047066").
// Replace each with the participant's name at render time (non-destructive — the
// stored content keeps the LID) using the Wali-sourced LID→{name,phone} map.
// Unknown LIDs are left as-is. Regenerate lidNameMap.js from the Wali export.
//
// linked=true renders a markdown link "[@Name](#wamention-<phone>)" so the thread
// can make mentions clickable (a click handler opens that number's chat); the plain
// form "@Name" is used for the conversation-list preview.
export const WA_MENTION_HREF_PREFIX = '#wamention-';

export const resolveLidMentions = (text, { linked = false } = {}) =>
  (text || '').replace(/@(\d{8,})/g, (match, lid) => {
    const entry = lidNameMap[lid];
    if (!entry || !entry.name) return match;
    if (linked && entry.phone) {
      return `[@${entry.name}](${WA_MENTION_HREF_PREFIX}${entry.phone})`;
    }
    return `@${entry.name}`;
  });

// Make Malaysian mobile numbers in message text clickable: +60196471560,
// 0196471560, 012-3456789, and the international "+60 19-647 1560" (a space/dash
// after the +60 country code). A separator after the prefix is allowed ONLY for the
// explicit "+60" form — a bare "60 1234567" (e.g. "RM60 1234567", or a "60 100 120"
// dimensions list) is not a phone number, so prices/quantities aren't mislinkified.
// A click opens that number's chat (same #wamention- handler as @mentions). The
// negative lookbehind avoids matching digits inside a URL or a longer number/order id.
// "!" is excluded too: staff wrap numbers as !012-3456789! to dodge marketplace
// detectors, and a leading "!" + the generated [x](href) link forms markdown IMAGE
// syntax ![x](href) — which blanks the whole bubble instead of showing the number.
const PHONE_RE = /(?<![\d/@.!-])((?:\+60[-\s]?|60|0)1\d(?:[-\s]?\d){7,8})/g;

const normalizePhoneForSearch = raw => {
  const digits = raw.replace(/\D/g, '');
  return digits.startsWith('0') ? `60${digits.slice(1)}` : digits;
};

export const linkifyPhoneNumbers = text =>
  (text || '').replace(
    PHONE_RE,
    match =>
      `[${match}](${WA_MENTION_HREF_PREFIX}${normalizePhoneForSearch(match)})`
  );

export default resolveLidMentions;
